import { Grid, Typography, useMediaQuery } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { getStyles } from 'isotope-client'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'redux'
import CloudUpload from '@material-ui/icons/CloudUpload'
import ShowChart from '@material-ui/icons/ShowChart'
import TableChart from '@material-ui/icons/TableChart'
import Update from '@material-ui/icons/Update'
import { colors, LOCALE, NOM_ONGLET_GESTION_TACHES, ONGLET_GESTION_TACHE, SOLVER_STATUS, STEP_GESTION_TACHES, TYPE_DIALOG } from '../../../../../utils/constants'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import Button from '../../../../../components/Button'
import { useSnackbar } from '../../../../../components/layout/snackbar/SnackbarContext'
import { useGestionTacheContext } from '../../GestionTacheProvider'
import { injectPlanificationFilter } from '../../injectors/filterInjector'
import { ActionPanelContext, DetailsPanelContext, FilterPanelContext } from '../../../../../components/layout/rightPanels'
import { resetFilter, setFilterOpen } from '../../../planning/services/toolbar/toolbarAction'
import { StepIcon, StyledConnector, StyledLabel } from '../../../../common/stepper/Stepper'
import StyledTabs from '../../../../../components/layout/tab/StyledTabs'
import StyledTab from '../../../../../components/layout/tab/StyledTab'
import { injectExportSuiviAvancement } from '../../../suiviAvancement/injectors/exportPopin'
import IconButton from '../../../../../components/IconButton'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { LocalDate } from '../../../../../utils/date/local-date'
import { DateFormat as LocaleDateFormat, DateUnit, TimeFormat } from '../../../../../utils/date/model/date'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import EventIcon from '@material-ui/icons/Event'
import { validerPlanification } from '../../services/api'
import { getSemaine } from '../../gestionTachesApi'
import { DialogContext } from '../../../../../components/layout/dialog'
import { ETAT_SEMAINE } from '../../utils/constants'
import { DateFormat } from '../../../../../utils/dateConstants'
import CheckIcon from '@material-ui/icons/Check'
import FormButton from '../../../../../components/form/FormButton'
import PopinPlanification, { LAUNCH_SOLVER_TACHE_FORM } from '../../popin/PopinPlanification'
import { approveSolutionTache, launchSolverTaches } from '../../../../common/solver/solverApi'
import SchedulerPage from '../../../scheduler/SchedulerPage'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import FormattedMessageWithBold from '../../../../../components/FormattedMessageWithBold'
import { LocalDateTime } from '../../../../../utils/date/local-date-time'
import { useSolverStatusContext } from '../../../besoinsProduction/SolverStatusContextProvider'
import { EXPORT_SORTIE_FORM } from '../../../sortie/services/sortie.consts'
import { SORTIE_EXPORT_ORIGIN } from '../../../sortie/services/sortie.enums'
import ExportSortieDialog from '../../../sortie/components/ExportSortieDialog'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { EXPORT_ITEMS } from '../../services/gestionTache.consts'
import { exportSortie } from '../../../sortie/services/sortie.api'
import { checkExportStateUntilFound } from '../../../../../utils/exportUtils'
import MenuActions from '../../../../../components/MenuActions'
import { ELEMENTS_TO_DISPLAY } from '../../../scheduler/services/schedule.consts'
import { isIpsosenso } from '../../../../../utils/utils'
import { getUser } from '../../../../common/user/services/userSelectors'

const styles = () => getStyles({
	selectorWeekContainer: {
		gap: 20,
		paddingBottom: 5,
		minHeight: 40
	},
	selectorIconContainer: {
		height: 35,
		width: 35
	},
	descriptionText: {
		fontSize: 12,
		lineHeight: '15px',
		color: colors.text
	},
	selectorText: {
		fontStyle: 'normal',
		lineHeight: '18px',
		fontSize: 14,
		fontWeight: '600',
		color: '#000000',
		marginBottom: 4,
		textAlign: 'center'
	},
	bouton: {
		padding: '5px 26px'
	},
	tabBar: {
		borderBottom: '1px solid lightgray'
	},
	error: {
		color: colors.error,
		fontSize: 14,
		fontFamily: 'Lato',
		textAlign: 'start',
		fontWeight: 700
	}
})

const getOngletTaches = (user) => {
	let tabs = [
		NOM_ONGLET_GESTION_TACHES.SYNTHESE,
		NOM_ONGLET_GESTION_TACHES.RESSOURCES,
		NOM_ONGLET_GESTION_TACHES.PLANIFICATION
	]
	if (isIpsosenso(user)) {
		tabs.push(NOM_ONGLET_GESTION_TACHES.DEBUG)
	}
	return tabs
}

const getStepsHeader = () => {
	return [
		STEP_GESTION_TACHES.PLANNING,
		STEP_GESTION_TACHES.RESULTATS
	]
}

const exportItems = Object.values(EXPORT_ITEMS).map(item => ({
	action: item,
	name: item
}))

export const ToolbarStepIcon = (props) => {
	const icons = {
		1: <TableChart />,
		2: <ShowChart />
	}

	return (
		<StepIcon icons={icons} {...props} />
	)
}

const ToolBarTaches = ({
	classes,
	openPopinExportSuiviAvancement,
	resetFilter,
	user
}) => {
	const { onglet, setOnglet, semaineSelection, setSemaineSelection, semaineCourante, jourSelection, isResultat, setIsResultat } = useGestionTacheContext()
	const { snackSuccess, snackError } = useSnackbar()
	const steps = getOngletTaches(user)
	const headerSteps = getStepsHeader()
	const { formatMessage } = useIntl()
	const { closePanel: closeActionPanel } = useContext(ActionPanelContext)
	const { closePanel: closeDetailsPanel } = useContext(DetailsPanelContext)
	const { closePanel: closeFilterPanel } = useContext(FilterPanelContext)
	const { openDialog, closeDialog } = useContext(DialogContext)
	const { refreshHeaderData, setSemaineCourante } = useGestionTacheContext()
	const { solverTacheInfos, refreshSolverTacheInfos } = useSolverStatusContext()
	const hasResultsToApprove = solverTacheInfos?.status === SOLVER_STATUS.DONE
	const solverOutdated = solverTacheInfos?.status === SOLVER_STATUS.OUTDATED

	const [currentWeekId, setCurrentWeekId] = useState(semaineCourante ? LocalDate.fromString(semaineCourante.debutSemaine, DateFormat.yyyy_MM_dd).format(LocaleDateFormat.SHORT_DATE_WITH_DASH) : undefined)
	const [showScheduler, setShowScheduler] = useState(false)

	const isLargeScreen = useMediaQuery('(min-width: 1600px)')

	// On désactive la navigation dans la planification en solution pour les semaines précedants la borne de début du solveur
	const previousWeekDisabled = useMemo(() => {
		if (isResultat && solverTacheInfos && solverTacheInfos.dateDebutPlanification && semaineCourante && semaineCourante.debutSemaine) {
			return LocalDate.fromString(semaineCourante.debutSemaine, DateFormat.yyyy_MM_dd)._diff(LocalDate.fromAPI(solverTacheInfos.dateDebutPlanification), 'weeks') < 0
		}
		return false
	}, [isResultat, solverTacheInfos, semaineCourante])

	useEffect(() => {
		if (semaineCourante) {
			setCurrentWeekId(
				LocalDate.fromString(semaineCourante.debutSemaine, DateFormat.yyyy_MM_dd).format(LocaleDateFormat.SHORT_DATE_WITH_DASH)
			)
		}
	}, [semaineCourante])

	useEffect(() => {
		refreshSolverTacheInfos()
	}, [isResultat])

	const openPopinPlanification = () => {
		openDialog(
			<Grid container justify="space-between">
				<Update style={{ paddingRight: 20, color: colors.primary }} />
				<FormattedMessage id="gestionTaches.toolbar.popin.runPlanification.titre" />
			</Grid>,
			<PopinPlanification
				onSubmit={(values) => {
					launchSolverTaches(values.useWeeks === 'weeks').then(() => {
						refreshSolverTacheInfos()
						closeDialog()
					})
				}}
				semaineCourante={semaineCourante}
			/>,
			[
				<FormButton variant="text" withBorder={false} formName={LAUNCH_SOLVER_TACHE_FORM}>
					<FormattedMessage id="gestionTaches.toolbar.popin.runPlanification.validation" />
				</FormButton>
			],
			TYPE_DIALOG.ACTION,
			undefined,
			undefined,
			false
		)
	}

	const openPopinApprobation = () => {
		openDialog(
			<Grid container justify="space-between">
				<CheckCircleOutlineIcon style={{ paddingRight: 20, color: colors.primary }} />
				<FormattedMessage id="gestionTaches.toolbar.popin.approvePlanification.title" />
			</Grid>,
			<Grid container style={{ padding: '10px 20px' }}>
				<FormattedMessage
					id="gestionTaches.toolbar.popin.approvePlanification.message"
					values={{
						start: LocalDate.fromAPI(solverTacheInfos.dateDebutPlanification).format(LocaleDateFormat.SHORT_DATE),
						end: LocalDate.fromAPI(solverTacheInfos.dateFinPlanification).minus(1, 'day').format(LocaleDateFormat.SHORT_DATE)
					}} />
			</Grid>,
			[
				<Button
					variant="text"
					withBorder={false}
					onClick={() => {
						refreshSolverTacheInfos()
						approveSolutionTache()
							.finally(() => refreshSolverTacheInfos())
						closeDialog()
					}}
				>
					<FormattedMessage id="actions.confirm" />
				</Button>
			], TYPE_DIALOG.ACTION
		)
	}

	const handleStep = (step) => () => {
		if (semaineCourante) {
			closeActionPanel()
			closeDetailsPanel()
			closeFilterPanel()
			resetFilter()

			if (step === ONGLET_GESTION_TACHE.RESSOURCES || step === ONGLET_GESTION_TACHE.PLANIFICATION) {
				setSemaineSelection(semaineSelection)
			}
			setOnglet(step)
		} else {
			snackError({ id: 'gestionTaches.ecranRessources.snackbar.errors.initializeBefore' })
		}
	}

	const handleValiderPlanification = React.useCallback(
		() => validerPlanification(LocalDate.fromString(currentWeekId, DateFormat.yyyy_MM_dd).format(LocaleDateFormat.SHORT_DATE_WITH_DASH))
			.then(() => getSemaine(LocalDate.fromString(currentWeekId, DateFormat.yyyy_MM_dd).format(LocaleDateFormat.SHORT_DATE_WITH_DASH)))
			.then((semaine) => {
				snackSuccess({ id: 'gestionTaches.ecranPlanification.validation.snackSuccess' })
				refreshHeaderData()
				setSemaineCourante(semaine)
			})
			.catch((e) => {
				if (e && e.response && e.response.status === 400) {
					openDialog(
						{ id: 'gestionTaches.ecranPlanification.validation.tacheNonAffecteesPopin.title' },
						<span style={{ padding: 20 }}>
							<FormattedMessage id="gestionTaches.ecranPlanification.validation.tacheNonAffecteesPopin.message">
								{text => <div className={classes.validationErrorPopupContent}>{text}</div>}
							</FormattedMessage>
						</span>,
						[]
					)
				} else {
					snackError()
				}
			}),
		[semaineSelection, snackSuccess, jourSelection, refreshHeaderData, setSemaineCourante, openDialog, classes, snackError, isResultat]
	)


	const formatWeekTitle = (weekId) => {
		const week = LocalDate.fromString(weekId, DateFormat.yyyy_MM_dd)
		return formatMessage({ id: 'gestionTaches.toolbar.selecteur.week' }, {
			weekNumber: week.weekNumber,
			start: week.startOf().format(LocaleDateFormat.SHORT_DATE_2_DIGITS_2_MONTH),
			end: week.endOf(DateUnit.week).format(LocaleDateFormat.SHORT_DATE_2_DIGITS_2_MONTH),
			b: (chunks) => <Typography className={classes.selectorText}>{chunks}</Typography>
		})
	}

	// Go to the next week
	const goNextWeek = () => {
		const nextWeek = LocalDate.fromString(currentWeekId, DateFormat.yyyy_MM_dd).plus(1, DateUnit.week)
		setSemaineSelection(nextWeek.format(LocaleDateFormat.REVERSE_SHORT_DATE))
		setCurrentWeekId(nextWeek.format(LocaleDateFormat.SHORT_DATE_WITH_DASH))
	}

	// Go to the previous week
	const goPreviousWeek = () => {
		const previousWeek = LocalDate.fromString(currentWeekId, DateFormat.yyyy_MM_dd).minus(1, DateUnit.week)
		setSemaineSelection(previousWeek.format(LocaleDateFormat.REVERSE_SHORT_DATE))
		setCurrentWeekId(previousWeek.format(LocaleDateFormat.SHORT_DATE_WITH_DASH))
	}

	/* Si la date de début et la date de fin sont dans la même semaine, on affiche que la semaine concernée */
	const renderMessage = () => {
		const weekDebut = LocalDate.fromAPI(solverTacheInfos?.dateDebutPlanification).weekNumber
		// on fait plus(-1, 'day') pour qu'on affiche le dimanche précédent la fin de la période (car on reçoit le lundi suivant la période à 0h)
		const weekFin = LocalDate.fromAPI(solverTacheInfos?.dateFinPlanification).minus(1).weekNumber
		if (weekDebut === weekFin) {
			return <FormattedMessageWithBold id="gestionTaches.toolbar.buttons.periodesSolveurDay" values={{
				semaineDebut: weekDebut,
				debut: LocalDateTime.fromAPI(solverTacheInfos?.dateDebutPlanification)?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR),
				fin: LocalDateTime.fromAPI(solverTacheInfos?.dateFinPlanification)?.plus(-1, 'day')?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR)
			}} />
		} else {
			return <FormattedMessageWithBold id="gestionTaches.toolbar.buttons.periodesSolveurWeek" values={{
				semaineDebut: weekDebut,
				semaineFin: weekFin,
				debut: LocalDateTime.fromAPI(solverTacheInfos?.dateDebutPlanification)?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR),
				// on fait plus(-1, 'day') pour qu'on affiche le dimanche précédent la fin de la période (car on reçoit le lundi suivant la période à 0h)
				fin: LocalDateTime.fromAPI(solverTacheInfos?.dateFinPlanification)?.plus(-1, 'day')?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR)
			}} />
		}
	}

	/**
	 * renvoie le bouton de planification ou le bouton d'approbation de la solution
	 * @returns {Element}
	 */
	const renderBoutons = () => {
		// si on est dans l'onglet résultat et qu'il y a des résultat à approuver (ie. le solver est au statut DONE)
		if (isResultat && hasResultsToApprove) {
			return <Button
				type="secondary"
				startIcon={isResultat ? <CheckIcon /> : <Update />}
				onClick={() => openPopinApprobation(semaineCourante)}
				className={classes.bouton}
			>
				<FormattedMessage id="gestionTaches.toolbar.buttons.approuver" />
			</Button>
		} else if (!isResultat) { // si on est dans l'onglet planning actuel
			return <Button
				type="secondary"
				startIcon={isResultat ? <CheckIcon /> : <Update />}
				onClick={() => openPopinPlanification()}
				className={classes.bouton}
			>
				<FormattedMessage id="gestionTaches.toolbar.buttons.planification" />
			</Button>
		}
	}

	const handleClickExport = (item) => {
		if (item.action === EXPORT_ITEMS.PLANNING) {
			openPopinExportSuiviAvancement()
		} else if (item.action === EXPORT_ITEMS.RECOLTE_THEORIQUE_SEMAINE) {
			openExportRecolteTheorique()
		}
	}

	const openExportRecolteTheorique = () => {
		openDialog(
			<Grid container spacing={1}>
				<OpenInNewIcon className={classes.popinTitleIcon} />
				<FormattedMessage id="sorties.export.title" />
			</Grid>,
			<ExportSortieDialog
				origin={SORTIE_EXPORT_ORIGIN.PLANIFICATION_TACHES}
				form={EXPORT_SORTIE_FORM}
				onSubmit={(values) => exportSortie(values)
					.then(checkExportStateUntilFound(snackSuccess))
					.then(closeDialog)
					.catch(() => snackError({ id: 'sorties.export.error' }))}
			/>,
			[
				<FormButton
					type="primary"
					formName={EXPORT_SORTIE_FORM}
				>
					<FormattedMessage id="actions.export" />
				</FormButton>
			], TYPE_DIALOG.ACTION,
			'actions.close',
			undefined,
			true
		)
	}

	/**
	 * Gestion du stepper et de la navigation de celui ci
	 * @param step étape sur laquelle l'utilisateur a cliqué
	 */
	const onStepTacheClick = (step) => {
		if (step.isResultat && (hasResultsToApprove || solverOutdated)) { // si le step est celui des résultats
			setIsResultat(true)
		} else if (!step.isResultat) { // si le step est celui du planning
			setIsResultat(false)
		}
	}

	return (
		<Grid container direction="column" justify="space-between" className={classes.content}>
			<Grid container item direction="row">
				<Grid container item direction="column" xs={3} justify="space-between" alignItems="flex-start" style={{ padding: 18 }}>
					<Typography variant="h2" className={classes.head}>
						<FormattedMessage id="gestionTaches.toolbar.text.planificationDesTaches" />
					</Typography>
					{!isResultat && <>
						<MenuActions
							items={{ export: exportItems }}
							onClick={(ev, category, item) => handleClickExport(item)}
							formattedMessageId="gestionTaches.toolbar.buttons"
							placement="bottom"
						>
							<Button
								type="secondary"
								startIcon={<CloudUpload />}
								className={classes.bouton}
							>
								<FormattedMessage id="gestionTaches.toolbar.buttons.export.global" />
							</Button>
						</MenuActions>
					</>}
				</Grid>
				<Grid item container direction="column" xs={isLargeScreen ? 6 : 5} justify="space-evenly" alignItems="center" style={{ paddingLeft: isLargeScreen ? 0 : '7%' }}>
					<Stepper alternativeLabel connector={<StyledConnector />} activeStep={headerSteps.find(s => s.isResultat === isResultat).order}>
						{headerSteps.map(step => (
							<Step key={step.isResultat} onClick={() => onStepTacheClick(step)}>
								<StyledLabel classes={classes.label} StepIconComponent={ToolbarStepIcon} StepIconProps={{ clickable: (step.isResultat && (hasResultsToApprove || solverOutdated)) || (!step.isResultat) }} large>{step.nom}</StyledLabel>
							</Step>
						))}
					</Stepper>
					<Grid item container xs direction="row" justify="center" alignItems="center" className={classes.selectorWeekContainer}>
						{(onglet !== ONGLET_GESTION_TACHE.SYNTHESE && onglet !== ONGLET_GESTION_TACHE.DEBUG) && <>
							<IconButton
								className={classes.selectorIconContainer}
								onClick={goPreviousWeek}
								disabled={previousWeekDisabled}
							>
								<ArrowBackIosIcon />
							</IconButton>
							<Typography className={classes.descriptionText}>
								{formatWeekTitle(currentWeekId)}
							</Typography>
							<IconButton className={classes.selectorIconContainer} onClick={goNextWeek}>
								<ArrowForwardIosIcon />
							</IconButton>
						</>}
					</Grid>
				</Grid>
				<Grid container item direction="column" xs={isLargeScreen ? 3 : 4} alignItems="flex-end" style={{ padding: 18, gap: 20 }}>
					{(!isResultat && (semaineCourante && semaineCourante.etat === ETAT_SEMAINE.BROUILLON)) &&
						<Button
							type="primary"
							startIcon={<PlaylistAddCheckIcon />}
							onClick={handleValiderPlanification}
							className={classes.bouton}
						>
							<FormattedMessage id="gestionTaches.toolbar.buttons.validerPlanification" />
						</Button>
					}
					{isResultat && (
						<Grid>
							{solverOutdated && isResultat &&
								<Grid item className={classes.error}>
									<Typography variant="error" className={classes.error}>
										<FormattedMessage id="gestionTaches.solveur.error.solutionOutdated" />
									</Typography>
								</Grid>
							}
							{solverTacheInfos?.userGeneration && <Grid item>
								<Typography variant="body1">
									<FormattedMessageWithBold id="solveurs.infos.generatedSolution" values={{
										user: solverTacheInfos?.userGeneration,
										date: LocalDateTime.fromAPI(solverTacheInfos?.dateLancementSolverTache)?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR),
										heure: LocalDateTime.fromAPI(solverTacheInfos?.dateLancementSolverTache)?.toDisplayDate(TimeFormat.TIME_ONLY, LOCALE.localeFR)
									}} />
								</Typography>
							</Grid>}
							{solverTacheInfos?.userSauvegarde && <Grid item>
								<Typography variant="body1">
									<FormattedMessageWithBold id="solveurs.infos.savedSolution" values={{
										user: solverTacheInfos?.userSauvegarde,
										date: LocalDateTime.fromAPI(solverTacheInfos?.dateApprobationSolutionTache)?.toDisplayDate(LocaleDateFormat.SHORT_DATE, LOCALE.localeFR),
										heure: LocalDateTime.fromAPI(solverTacheInfos?.dateApprobationSolutionTache)?.toDisplayDate(TimeFormat.TIME_ONLY, LOCALE.localeFR)
									}} />
								</Typography>
							</Grid>
							}
							<Grid item>
								<Typography variant="body1">
									{renderMessage()}
								</Typography>
							</Grid>
						</Grid>
					)}
					<Grid container item direction="row" justify="flex-end" alignItems="space-between" style={{ gap: 2 }}>
						<Button
							type="secondary"
							startIcon={<EventIcon />}
							onClick={() => setShowScheduler(true)}
							className={classes.bouton}
							withBorder={false}
						>
							<FormattedMessage id="schedule.action.show" />
						</Button>
						{renderBoutons()}
					</Grid>
				</Grid>
			</Grid>
			<Grid item container justify="center" alignContent="flex-end" direction="row" className={classes.tabBar}>
				<StyledTabs value={onglet}>
					{steps.map((label, index) => (
						<StyledTab onClick={handleStep(index)} key={index} label={label} withoutBorder />
					))}
				</StyledTabs>
			</Grid>
			<SchedulerPage
				open={showScheduler}
				isResultat={isResultat}
				handleClose={() => setShowScheduler(false)}
				ressourcesToDisplay={ELEMENTS_TO_DISPLAY.RESSOURCES}
			/>
		</Grid>
	)
}

ToolBarTaches.propTypes = {
	classes: PropTypes.object,
	resetFilter: PropTypes.func
}

const actions = {
	setFilterOpen,
	resetFilter
}

const mapStateToProps= (state) => ({
	user: getUser(state)
})

export default compose(
	connect(mapStateToProps, actions),
	injectExportSuiviAvancement,
	injectPlanificationFilter,
	withStyles(styles)
)(ToolBarTaches)
